//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Back from "@/common/components/back/index.vue";
import { commonApi } from "@/common/index";
export default {
  name: "Ranking",
  components: {
    Back,
  },
  data() {
    return {
      rankingData: new Array(10).fill({
        userAccount: "",
        totalFlow: "",
      }),
      myData: {},
      myHistoryData: {},
      rules: "",
    };
  },
  computed: {
    rankExceptTop() {
      // 计算除前三名外的排名数据
      return this.rankingData.slice(3);
    },
  },
  methods: {
    getRankingData() {
      commonApi.HOMEBEFORE.getBonusRanking({ queryType: 0 }).then((res) => {
        if (res.data) {
          this.rankingData = res.data;
        }

        this.myData = res.myData || {};
      });
    },
    getHistoryRanking() {
      commonApi.HOMEBEFORE.getBonusRanking({ queryType: 1 }).then((res) => {
        this.myHistoryData = res.myData || {};
      });
    },
    getRules() {
      commonApi.HELP.articleById("10003")
        .then((data) => {
          this.rules = data.content;
        })
        .catch((err) => {
          this.$toast({
            message: err,
            icon: "warning",
          });
        });
    },
  },
  activated() {
    // 页面激活时调用
    this.getRankingData();
    this.getHistoryRanking();
    this.getRules();
  },
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/ranking/index.vue